
require.register("react-bootstrap/node_modules/core-js/library/modules/$.core.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "react-bootstrap/node_modules/core-js");
  (function() {
    var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
  })();
});